export default __webpack_public_path__ + "static/media/about-hand-written-3.be58258b.png";